import { useState } from "react"
import { Box, Typography, Tooltip, ClickAwayListener } from "@mui/material"
import InfoOutlined from "@mui/icons-material/InfoOutlined"
import { useTranslation } from "react-i18next"
import { styles } from "./RecommendationTooltip.styles"

export const RecommendationTooltip = ({ recommendation, sx }) => {
  const { t } = useTranslation()
  const [openTooltip, setOpenTooltip] = useState(false)

  if (!recommendation) return null

  const handleTooltipClose = () => setOpenTooltip(false)
  const handleTooltipOpen = () => setOpenTooltip(true)
  const handleTooltipToggle = (e) => {
    e?.stopPropagation?.()
    setOpenTooltip((prev) => !prev)
  }

  return (
    <ClickAwayListener onClickAway={handleTooltipClose}>
      <Box component="span" sx={[styles.recommendationIconWrapper, sx]}>
        <Tooltip
          open={openTooltip}
          onClose={handleTooltipClose}
          onOpen={handleTooltipOpen}
          title={
            <Box sx={styles.recommendationPopover}>
              <Typography
                variant="body2"
                fontWeight="bold"
                sx={styles.recommendationTitle}
              >
                {t(recommendation.titleKey, recommendation.titleDefault)}
              </Typography>
              <Typography variant="body2">
                {t(recommendation.key, recommendation.defaultText)}
              </Typography>
            </Box>
          }
          arrow
          placement="bottom-start"
          disableFocusListener
          disableTouchListener
          componentsProps={{
            tooltip: {
              sx: styles.recommendationTooltip,
            },
            arrow: {
              sx: styles.recommendationArrow,
            },
          }}
        >
          <Box
            component="span"
            onClick={handleTooltipToggle}
            onMouseEnter={handleTooltipOpen}
            onMouseLeave={handleTooltipClose}
            sx={styles.recommendationIconInner}
          >
            <InfoOutlined fontSize="small" sx={styles.recommendationIcon} />
          </Box>
        </Tooltip>
      </Box>
    </ClickAwayListener>
  )
}
